import React, { useState } from 'react';
import IntegrationsPanel from './IntegrationsPanel';
import AdminSettingsPanel from './AdminSettingsPanel';

const TABS = [
  { key: 'tools', label: '3rd Party Tools' },
  { key: 'org', label: 'Organization' },
];

export default function HqSettingsPanel({ orgId, teams }) {
  const [tab, setTab] = useState('tools');
  return (
    <div className="space-y-4" data-testid="hq-settings-panel">
      <div className="flex items-center gap-2 border-b border-slate-700 pb-2">
        {TABS.map(t => (
          <button key={t.key} onClick={() => setTab(t.key)}
            className={`px-3 py-1.5 text-sm font-semibold rounded-md transition-colors ${tab === t.key ? 'bg-amber-500 text-white' : 'text-slate-300 hover:text-white'}`}
            data-testid={`hq-settings-tab-${t.key}`}>
            {t.label}
          </button>
        ))}
      </div>
      {tab === 'tools' && <IntegrationsPanel />}
      {tab === 'org' && (orgId
        ? <AdminSettingsPanel orgId={orgId} teams={teams} />
        : <p className="text-slate-400 p-8">No organization available</p>)}
    </div>
  );
}
